'use strict';

DoohApps
.factory('ScreensData', ['restApi', function (restApi) {
    var controllerName = 'MediaScreen/';

    return {
        getScreensForSchedule: function (successCallback,includeGroups) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetScreensForSchedule?groups='+includeGroups);
        },
        getApplicationsForScreen: function (successCallback, filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetApplicationsForScreen', filter);
        },
        getScreenConfigs: function (successCallback) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetScreenConfigs');
        },
        getScreenConfigDetails: function (sucessCallback, mediaId) {
            restApi.GetApiMethod(sucessCallback, controllerName + 'GetScreenConfigDetails?mediaId='+mediaId);
        },
        updateScreenDetails: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'UpdateScreenDetails', data);
        },
        compareDeviceColors: function (sucessCallback, deviceColorData) {
            restApi.GetApiMethod(sucessCallback, controllerName + 'CompareDeviceColors', deviceColorData);
        },
        getScreenConfigsForCompany: function (successCallback, filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetScreenConfigsForCompany', filter);
        },
        newVirtualDevice: function (successCallback, device) {
            restApi.PostApiMethod(successCallback, controllerName + 'NewVirtualDevice', device);
        },
    }
}])
.factory('ScreensFilterData', function () {
    var DataFilter = {};

    DataFilter.SetDefault = function () {
        DataFilter.SelectedScreen = {};
    };
    DataFilter.SetDefault();

    DataFilter.Clear = function () {
        DataFilter.SetDefault();
    }

    DataFilter.prepSelectedScreen = function (that) {
        this.SelectedScreen = that;
    }

    return DataFilter;
})
